// 这里不校验 eqeqeq，因为后面有些地方需要用到 == 来做类型转换判断
/* eslint-disable eqeqeq */

// import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
// import Toast from '../components/Toast.vue';
import { mapGetters } from 'vuex';
import { holeAddressList, truncateDecimals, multiply, parseData, divide } from '../utils';
import { reqTokenSecurity, reqTokenById, reqTokenInfo } from '../api';
// import { CHAIN_INFO_MAP, BLOCKCHAINID_NETWORK } from '../constants';
// import { cloneDeep } from 'lodash';

const enuTrade = [
    'is_honeypot', // 貔貅代币 1:是 0:否
    'slippage_modifiable', // 交易税可改 1:是 0:否 0是安全
    'transfer_pausable', // 可暂停交易 1:是 0:否 0是安全
    'is_blacklisted', // 黑名单 1:是 0:否
    'is_whitelisted', // 白名单 1:是 0:否
    'is_anti_whale', // 防巨鲸 1:是 0:否
    'cannot_buy', // 不能买入 1:是 0:否
    'cannot_sell_all', // 不能全部卖出 1:是 0:否
    'trading_cooldown', // 是否有交易冷却 1:是 0:否
    'personal_slippage_modifiable', // 是否可修改指定地址的税率 1:是 0:否
    'anti_whale_modifiable', // 是否可修改防巨鲸限制 1:是 0:否
];

const enuCertikTrade = [
    'is_honeypot', // 貔貅代币 1:是 0:否 0是安全
    'is_transfer_pausable', // 可暂停交易 1:是 0:否 0是安全
    'cannot_buy', // 不能买入 1:是 0:否 0是安全
    'cannot_sell_all', // 不能全部卖出 1:是 0:否 0是安全
    'is_transfer_cooldown', // 是否有交易冷却 1:是 0:否 0是安全
    'is_anti_whale', // 防巨鲸 1:是 0:否 0是安全
    'can_modify_tax', // 交易税可改 1:是 0:否 0是安全
    'has_blacklist', // 黑名单 1:是 0:否 0是安全
    'has_whitelist', // 白名单 1:是 0:否 0是安全
    'is_anti_whale_modifiable', // 是否可修改防巨鲸限制 1:是 0:否 0是安全
    'has_external_calls', // 是否有外部调用 1:是 0:否 0是安全
    'can_self_destruct', // 是否有自毁合约 1:是 0:否 0是安全
    // 'major_holder_ratio', // 大户集中度过高 > 50% 红 <= 50% 绿
];

const enuContract = [
    'is_airdrop_scam', // 空投诈骗 1:是 0:否 0是安全
    'is_true_token', // 是否为真币 1:是 0:否
    'is_open_source', // 代码开源 1:是 0:否
    'is_proxy', // 代理合约 1:是 0:否 0是安全
    'is_mintable', // 是否有增发功能 1:是 0:否 0是安全
    'owner_change_balance', // 是否可以修改用户余额 1:是 0:否 0是安全
    'hidden_owner', // 是否隐藏 Owner 地址 1:是 0:否 0是安全
    'can_take_back_ownership', // 是否可以取回源所有权 1:是 0:否 0是安全
    'selfdestruct', // 自毁合约 1:是 0:否 0是安全
    'external_call', // 外部方法 1:是 0:否 0是安全
];

const enuCertikContract = [
    'not_open_source', // 代码是否开源 1:是 0:否
    'is_proxy_contract', // 是否为代理合约 1:是 0:否 0是安全
    'is_mintable', // 是否有增发功能 1:是 0:否 0是安全
    'can_modify_balance', // 是否可以修改用户余额 1:是 0:否 0是安全
    'can_regain_ownership', // 是否可以取回源所有权 1:是 0:否 0是安全
    'has_hidden_owner', // 是否有隐藏 owner 1:是 0:否 0是安全
];

//  sol 总共 27 项检测
const enuSolTrade = [
    'freezable', // 交易冻结
    'transfer_fee_upgradable', // 交易税率可更改
];

// 'fee_in_basis_points', // 手续费 < 5% 正常， 大于等于5%，小于20% 中风险， 大于等于20% 高风险
const enuCertikSolTrade = [
    'freeze_authority', // 交易冻结 true:异常 false:正常
    'interest_rate', // 是否有利率机制 true:异常 false:正常
    'rate_authority', // 是否有利率授权机制 true:异常 false:正常
    // 'liquidity_control', // 流动性分布是否正常 true:异常 false:正常
    // 'major_holders_ratio', // 持有人分布是否正常 true:异常 false:正常
    // 'initial_distribution', // 初始分配分布是否正常 true:异常 false:正常
    'transfer_fee_authority', // 是否存在手续费授权权限 true:异常 false:正常
    'transfer_fee_extension', // 是否存在手续费拓展功能 true:异常 false:正常
    'confidential_transfer_extension', // 是否存在保密转账功能 true:异常 false:正常
    'interest_bearing_token_extension', // 有息代币 true:异常 false:正常
];

const enuSolContract = [
    'default_account_state', // 代币创建状态是否正常
    'non_transferable', // 代币是否能转账
    'creators', // 创建者是恶意地址
    'transfer_hook', // 是否存在外部程序
    'trusted_token', // 信任代币
];

const enuCertikSolContract = [
    'non_transferable_token_extension', // 代币是否能转账 true:异常 false:正常
    'transfer_hook_extension', // 是否存在外部程序 true:异常 false:正常
];

const enuSolTokenAnalysis = [
    'metadata_mutable', // 元数据是否可变更
    'mintable', // 是否存在增发功能
    'closable', // 是否存在关闭功能
    'default_account_state_upgradable', // 账户状态可升级
    'balance_mutable_authority', // 修改余额
    'transfer_hook_upgradable', // 外部程序可升级
];

const enuSolCertikTokenAnalysis = [
    'mint_authority', // 是否存在增发功能 true:异常 false:正常
    'token_metadata_changeable', // 元数据是否可变更 true:异常 false:正常
    'closing_mint_extension', // 是否存在关闭功能 true:异常 false:正常
    'token_launch_time', // 新代币
    'withdraw_withheld_authority', // 是否存在收回授权 true:异常 false:正常
    'permanent_delegate_extension', // 是否存在代表拓展 功能 true:异常 false:正常
];

// Certik -> GoPlus 字段映射：用于把 Certik 的 label 统一成 GoPlus 的字段名（方便复用 i18n/展示规则）
const certikToGoPlusLabelMap = {
    // EVM
    not_open_source: 'is_open_source',
    is_proxy_contract: 'is_proxy',
    is_mintable: 'is_mintable',
    can_modify_balance: 'owner_change_balance',
    can_regain_ownership: 'can_take_back_ownership',
    has_hidden_owner: 'hidden_owner',

    is_transfer_pausable: 'transfer_pausable',
    can_modify_tax: 'slippage_modifiable',
    is_transfer_cooldown: 'trading_cooldown',
    is_anti_whale: 'is_anti_whale',
    is_anti_whale_modifiable: 'anti_whale_modifiable',
    has_blacklist: 'is_blacklisted',
    has_whitelist: 'is_whitelisted',
    has_external_calls: 'external_call',
    can_self_destruct: 'selfdestruct',

    // 同名字段直接对齐
    is_honeypot: 'is_honeypot',
    cannot_buy: 'cannot_buy',
    cannot_sell_all: 'cannot_sell_all',

    // Sol: 同义字段（数据源字段不同）
    freeze_authority: 'freezable',
    non_transferable_token_extension: 'non_transferable',
    transfer_hook_extension: 'transfer_hook',
    token_metadata_changeable: 'metadata_mutable',
    closing_mint_extension: 'closable',
    mint_authority: 'mintable',
};

// 如果后续需要把 GoPlus 统一成 Certik，可用这个反向映射
/* const goPlusToCertikLabelMap = Object.fromEntries(
    Object.entries(certikToGoPlusLabelMap).map(([certikKey, goPlusKey]) => [goPlusKey, certikKey])
); */

export default {
    props: {
        token: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isDetectionResult: false, // 是否有检测结果返回（无结果时不展示安全模块）
            tradeList: [],
            contractList: [],
            taxList: [],
            tokenAnalysis: [],
            tokenIcon: '',
            showCount: 1000,
            isTokenSecurity: false,
            // currentNeedAddToken: null,
            // isLoading: false,
            goPlusTax: {
                buy: null,
                sell: null,
            },
            certikTax: {
                buy: null,
                sell: null,
            },

            // Certik 独立的检测项列表（用于与 GoPlus 做对比展示）
            certikTradeList: [],
            certikContractList: [],
            certikTokenAnalysis: [],
            certikTxList: [],
            epoch: 0,
            // isSol: false,
            tokenSecurityInterval: null,

            // 用于 UI 决定显示 GoPlus/Certik 哪些列：是否有对应数据源返回
            hasGoPlusSecuritySource: false,
            hasCertikSecuritySource: false,
        };
    },

    computed: {
        ...mapGetters(['isDark']),
        showGoPlusSecurityColumn() {
            const hasGoPlus = !!this.hasGoPlusSecuritySource;
            const hasCertik = !!this.hasCertikSecuritySource;
            // 两个数据源都没有时：保持旧行为，仍展示两列（仅展示占位/未知）
            if (!hasGoPlus && !hasCertik) return true;
            return hasGoPlus;
        },
        showCertikSecurityColumn() {
            const hasGoPlus = !!this.hasGoPlusSecuritySource;
            const hasCertik = !!this.hasCertikSecuritySource;
            // 两个数据源都没有时：保持旧行为，仍展示两列（仅展示占位/未知）
            if (!hasGoPlus && !hasCertik) return true;
            return hasCertik;
        },
        // 将 GoPlus 与 Certik 的检测项按同一 label 聚合，便于在一行展示两列结果
        securityItemsAll() {
            const map = new Map();
            const mapCertikLabel = key => certikToGoPlusLabelMap[key] || key;
            const solGoPlusDefaultLabels = [
                ...enuSolTrade,
                ...enuSolContract,
                ...enuSolTokenAnalysis,
                'scheduled_fee_rate',
            ].filter(label => label !== 'trusted_token');
            // 关键：EVM 和 Sol 的检测项枚举完全不同，空状态补齐时不能混用
            const goPlusSupportedLabels = new Set(this.isSol ? solGoPlusDefaultLabels : [...enuTrade, ...enuContract]);
            let certikSupportedLabelsArr = [];
            if (this.isSol) {
                certikSupportedLabelsArr = [
                    ...enuCertikSolTrade.map(mapCertikLabel),
                    ...enuCertikSolContract.map(mapCertikLabel),
                    ...enuSolCertikTokenAnalysis.map(mapCertikLabel),
                    'scheduled_fee_rate',
                ];
            } else {
                certikSupportedLabelsArr = [
                    ...enuCertikTrade.map(mapCertikLabel),
                    ...enuCertikContract.map(mapCertikLabel),
                ];
            }
            const certikSupportedLabels = new Set(certikSupportedLabelsArr);

            // 用于 securityList() 分类展示：必须覆盖“GoPlus+Certik 并集”，否则空状态会被过滤掉
            const tradeLabels = new Set(
                this.isSol
                    ? [...enuSolTrade, ...enuCertikSolTrade.map(mapCertikLabel), 'scheduled_fee_rate']
                    : [...enuTrade, ...enuCertikTrade.map(mapCertikLabel)]
            );
            const contractLabels = new Set(
                this.isSol
                    ? [...enuSolContract, ...enuCertikSolContract.map(mapCertikLabel)]
                    : [...enuContract, ...enuCertikContract.map(mapCertikLabel)]
            );
            const analysisLabels = new Set(
                this.isSol ? [...enuSolTokenAnalysis, ...enuSolCertikTokenAnalysis.map(mapCertikLabel)] : []
            );
            const categoryForLabel = label => {
                if (!label) return undefined;
                if (tradeLabels.has(label)) return 'trade';
                if (contractLabels.has(label)) return 'contract';
                if (analysisLabels.has(label)) return 'analysis';
                return undefined;
            };
            let safeTaxList = [];
            if (Array.isArray(this.taxList)) {
                safeTaxList = this.taxList;
            } else if (this.taxList) {
                safeTaxList = [this.taxList];
            }

            let safeCertikTxList = [];
            if (Array.isArray(this.certikTxList)) {
                safeCertikTxList = this.certikTxList;
            } else if (this.certikTxList) {
                safeCertikTxList = [this.certikTxList];
            }
            const certikTxRowMap = new Map(
                safeCertikTxList.filter(item => item && item.label).map(item => [item.label, item])
            );

            const ensureEntry = (label, category) => {
                if (!label) return null;
                if (!map.has(label)) {
                    map.set(label, {
                        label,
                        category,
                        status: 0,
                        goplus: null,
                        certik: null,
                    });
                }
                const entry = map.get(label);
                if (!entry.category && category) {
                    entry.category = category;
                }
                return entry;
            };

            const defaultResultForSource = (label, supportedLabels) => {
                if (!label) return '-';
                return supportedLabels && supportedLabels.has(label) ? 'unknown' : '-';
            };

            // 产品逻辑：检测项数量固定为 GoPlus + Certik（当前链）并集，无论有没有数据都要展示
            // 默认空状态显示 '-'（缺失某一侧数据也显示 '-'）
            const allSupportedLabels = new Set([...goPlusSupportedLabels, ...certikSupportedLabels]);
            allSupportedLabels.forEach(label => {
                const entry = ensureEntry(label, categoryForLabel(label));
                if (!entry) return;
                if (!entry.goplus) {
                    entry.goplus = {
                        status: 0,
                        result: defaultResultForSource(label, goPlusSupportedLabels),
                    };
                }
                if (!entry.certik) {
                    entry.certik = {
                        status: 0,
                        result: defaultResultForSource(label, certikSupportedLabels),
                    };
                }

                // Sol: token_launch_time（新代币）在无数据时也需要展示为 status=3
                if (label === 'token_launch_time') {
                    entry.status = 3;
                }
            });

            const attachMeta = (entry, row) => {
                if (!entry || !row) return;
                // tooltip/展示需要的一些附加字段（目前优先取第一个出现的数据源）
                // addresses：允许用“非空数组”覆盖“空数组”（解决 GoPlus 无外部程序、Certik 有外部程序时 tooltip 丢地址）
                if (Array.isArray(row.addresses) && row.addresses.length) {
                    if (!Array.isArray(entry.addresses) || entry.addresses.length === 0) {
                        entry.addresses = row.addresses;
                    }
                } else if (entry.addresses === undefined && row.addresses !== undefined) {
                    // 非数组类型的 addresses（兼容历史写法）仅在 entry 未设置时赋值
                    entry.addresses = row.addresses;
                }
                if (entry.scheduled === undefined && row.scheduled !== undefined) entry.scheduled = row.scheduled;
                if (entry.epoch1 === undefined && row.epoch1 !== undefined) entry.epoch1 = row.epoch1;
                if (entry.fee_rate === undefined && row.fee_rate !== undefined) entry.fee_rate = row.fee_rate;
                if (entry.scheduleList === undefined && row.scheduleList !== undefined)
                    entry.scheduleList = row.scheduleList;
                if (entry.transfer_hook === undefined && row.transfer_hook !== undefined)
                    entry.transfer_hook = row.transfer_hook;
                if (entry.metadata_mutable === undefined && row.metadata_mutable !== undefined)
                    entry.metadata_mutable = row.metadata_mutable;
            };

            const addRows = (rows = [], sourceKey, category) => {
                rows.forEach(row => {
                    const entry = ensureEntry(row.label, category);
                    if (!entry) return;
                    entry[sourceKey] = {
                        status: typeof row.status === 'number' ? row.status : 0,
                        result: row.result ?? '-',
                    };
                    entry.status = Math.max(entry.status, entry[sourceKey].status);
                    attachMeta(entry, row);
                });
            };

            addRows(this.tradeList, 'goplus', 'trade');
            addRows(this.contractList, 'goplus', 'contract');
            if (this.isSol) addRows(this.tokenAnalysis, 'goplus', 'analysis');
            // Sol: 交易税是否可调整（scheduled_fee_rate）来源于 taxList，但需要作为“检测项”展示在列表中
            if (this.isSol) addRows(safeTaxList, 'goplus', 'trade');

            addRows(this.certikTradeList, 'certik', 'trade');
            addRows(this.certikContractList, 'certik', 'contract');
            if (this.isSol) addRows(this.certikTokenAnalysis, 'certik', 'analysis');
            if (this.isSol) addRows(safeCertikTxList, 'certik', 'trade');

            // Sol: 若 Certik 有 scheduled_fee_rate，则以 Certik 的数据作为主结果/提示
            if (this.isSol) {
                certikTxRowMap.forEach((certikRow, label) => {
                    const entry = map.get(label);
                    if (!entry || !certikRow) return;
                    if (entry.certik && typeof entry.certik.status === 'number') {
                        entry.status = entry.certik.status;
                    }
                    if (certikRow.scheduled !== undefined) entry.scheduled = certikRow.scheduled;
                    if (certikRow.epoch1 !== undefined) entry.epoch1 = certikRow.epoch1;
                    if (certikRow.fee_rate !== undefined) entry.fee_rate = certikRow.fee_rate;
                    if (certikRow.scheduleList !== undefined) entry.scheduleList = certikRow.scheduleList;
                });
            }

            // 兜底：任何来源缺失的列统一展示 '-'
            map.forEach(entry => {
                if (!entry) return;
                if (!entry.goplus) {
                    entry.goplus = {
                        status: 0,
                        result: defaultResultForSource(entry.label, goPlusSupportedLabels),
                    };
                }
                if (!entry.certik) {
                    entry.certik = {
                        status: 0,
                        result: defaultResultForSource(entry.label, certikSupportedLabels),
                    };
                }
            });

            // 部分检测项在“安全”时按产品规则不展示
            const hideWhenSafeLabels = new Set([
                'cannot_buy',
                'cannot_sell_all',
                'is_airdrop_scam',
                'is_true_token',
                'confidential_transfer_extension',
                'interest_bearing_token_extension',
            ]);

            return Array.from(map.values()).filter(entry => {
                if (!entry || !entry.label) return false;
                if (!hideWhenSafeLabels.has(entry.label)) return true;
                return entry.status !== 0;
            });
        },
        // 买/卖税风险：不展示为检测项，但需要纳入风险计数
        // 规则：< 5% 安全；>= 5% && < 20% 中风险；>= 20% 高风险
        // 多数据源（GoPlus/Certik）时取“更高风险”的值
        taxRiskCounts() {
            const toNumberOrNull = v => {
                if (v === '' || v === null || v === undefined) return null;
                const n = typeof v === 'number' ? v : Number(v);
                return Number.isFinite(n) ? n : null;
            };

            const statusOf = n => {
                if (n === null) return null;
                if (n < 5) return 0;
                if (n < 20) return 1;
                return 2;
            };

            const maxFromSources = values => {
                const candidates = values.map(toNumberOrNull).filter(v => v !== null);
                if (!candidates.length) return null;
                const max = Math.max(...candidates);
                return Number.isFinite(max) ? max : null;
            };

            const buy = maxFromSources([this.goPlusTax.buy, this.certikTax.buy]);
            const sell = this.isSol ? null : maxFromSources([this.goPlusTax.sell, this.certikTax.sell]);

            const buyStatus = statusOf(buy);
            const sellStatus = statusOf(sell);

            return {
                risky: (buyStatus === 2 ? 1 : 0) + (sellStatus === 2 ? 1 : 0),
                attention: (buyStatus === 1 ? 1 : 0) + (sellStatus === 1 ? 1 : 0),
            };
        },

        shouldOnlyShowOpenSourceItem() {
            if (this.isSol) return false;

            // 这里读取的是聚合后的统一 label：
            // - GoPlus 原始字段是 is_open_source
            // - Certik 原始字段是 not_open_source，前面已映射成 is_open_source
            const openSourceRow = this.securityItemsAll.find(item => item && item.label === 'is_open_source');
            if (!openSourceRow) return false;

            const hasGoPlus = !!this.hasGoPlusSecuritySource;
            const hasCertik = !!this.hasCertikSecuritySource;

            // 只要任一实际返回的数据源判定“未开源”，就只展示 is_open_source 这一项
            const goPlusNotOpenSource = hasGoPlus && openSourceRow?.goplus?.result === 'No';
            const certikNotOpenSource = hasCertik && openSourceRow?.certik?.result === 'No';

            return goPlusNotOpenSource || certikNotOpenSource;
        },

        displaySecurityItems() {
            if (!this.shouldOnlyShowOpenSourceItem) {
                return this.securityItemsAll;
            }

            return this.securityItemsAll.filter(item => item && item.label === 'is_open_source');
        },

        displayTaxRiskCounts() {
            if (this.shouldOnlyShowOpenSourceItem) {
                return {
                    risky: 0,
                    attention: 0,
                };
            }

            return this.taxRiskCounts;
        },

        hasSecurityData() {
            const hasLists =
                (this.tradeList && this.tradeList.length) ||
                (this.contractList && this.contractList.length) ||
                (this.taxList && this.taxList.length) ||
                (this.tokenAnalysis && this.tokenAnalysis.length) ||
                (this.certikTradeList && this.certikTradeList.length) ||
                (this.certikContractList && this.certikContractList.length) ||
                (this.certikTokenAnalysis && this.certikTokenAnalysis.length) ||
                (this.certikTxList && this.certikTxList.length);

            // 税值为 'unknown'/空字符串时不算“有数据”，否则无数据场景会把 risky/attention 算成 0
            const hasNumericTax = v => {
                if (v === null || v === undefined) return false;
                if (v === '' || v === 'unknown') return false;
                if (typeof v === 'number') return Number.isFinite(v);
                const n = Number(v);
                return Number.isFinite(n);
            };
            const hasTaxValues =
                hasNumericTax(this.goPlusTax?.buy) ||
                hasNumericTax(this.goPlusTax?.sell) ||
                hasNumericTax(this.certikTax?.buy) ||
                hasNumericTax(this.certikTax?.sell);

            return Boolean(hasLists || hasTaxValues);
        },

        // status 2 高风险 1 中风险 0 安全 3 无风险，仅仅展示（以两数据源聚合后的最大风险为准）
        risky() {
            if (!this.hasSecurityData) return -1;
            const list = this.displaySecurityItems;
            const base = list.filter(t => t.status === 2).length;
            const total = base + this.displayTaxRiskCounts.risky;
            return total;
        },
        attention() {
            if (!this.hasSecurityData) return -1;
            const list = this.displaySecurityItems;
            const base = list.filter(t => t.status === 1).length;
            const total = base + this.displayTaxRiskCounts.attention;
            return total;
        },

        unknown() {
            if (this.risky === 0 && this.attention === 0) {
                const hasGoPlus = !!this.hasGoPlusSecuritySource;
                const hasCertik = !!this.hasCertikSecuritySource;

                // 只统计“实际有返回”的数据源，避免某源未返回但默认补 unknown 导致误判
                const hasUnknown = this.displaySecurityItems.some(t => {
                    if (!t) return false;
                    if (hasGoPlus && t?.goplus?.result === 'unknown') return true;
                    if (hasCertik && t?.certik?.result === 'unknown') return true;
                    return false;
                });
                if (hasUnknown) return this.$t('unknown');

                if (this.shouldOnlyShowOpenSourceItem) return '';

                const hasUnknownTax =
                    (hasGoPlus && (this.goPlusTax?.buy === 'unknown' || this.goPlusTax?.sell === 'unknown')) ||
                    (hasCertik && (this.certikTax?.buy === 'unknown' || this.certikTax?.sell === 'unknown'));
                if (hasUnknownTax) return this.$t('unknown');
                return '';
            }
            return '';
        },
        securityList() {
            const all = this.displaySecurityItems;
            const byCategory = (category, list) => list.filter(item => item.category === category);

            if (this.risky === 0 && this.attention === 0) {
                const arr = [
                    ...byCategory('contract', all),
                    ...byCategory('trade', all),
                    ...byCategory('analysis', all),
                ];
                return arr.slice(0, this.showCount);
            }

            const arr = [...byCategory('trade', all), ...byCategory('contract', all), ...byCategory('analysis', all)];
            const arr1 = arr.filter(item => item.status === 2);
            const arr2 = arr.filter(item => item.status === 1);
            const arr3 = arr.filter(item => item.status === 0);
            const arr4 = arr.filter(item => item.status === 3);

            return [...arr1, ...arr2, ...arr3, ...arr4].slice(0, this.showCount);
        },

        goPlusBuyTaxColor() {
            if (this.goPlusTax.buy === 'unknown') {
                return 'rgba(255, 113, 20, 0.7)';
            }
            if (this.goPlusTax.buy < 5) {
                if (this.isDark) {
                    return '#dddee1';
                } else {
                    return '#333333';
                }
            } else if (this.goPlusTax.buy >= 5 && this.goPlusTax.buy < 20) {
                return '#FF7114';
            } else {
                return '#E55036';
            }
        },

        goPlusSellTaxColor() {
            if (this.goPlusTax.sell === 'unknown') {
                return 'rgba(255, 113, 20, 0.7)';
            }
            if (this.goPlusTax.sell < 5) {
                if (this.isDark) {
                    return '#dddee1';
                } else {
                    return '#333333';
                }
            } else if (this.goPlusTax.sell >= 5 && this.goPlusTax.sell < 20) {
                return '#FF7114';
            } else {
                return '#E55036';
            }
        },

        certikBuyTaxColor() {
            if (this.certikTax.buy === 'unknown') {
                return 'rgba(255, 113, 20, 0.7)';
            }
            if (this.certikTax.buy < 5) {
                if (this.isDark) {
                    return '#dddee1';
                } else {
                    return '#333333';
                }
            } else if (this.certikTax.buy >= 5 && this.certikTax.buy < 20) {
                return '#FF7114';
            } else {
                return '#E55036';
            }
        },

        certikSellTaxColor() {
            if (this.certikTax.sell === 'unknown') {
                return 'rgba(255, 113, 20, 0.7)';
            }
            if (this.certikTax.sell < 5) {
                if (this.isDark) {
                    return '#dddee1';
                } else {
                    return '#333333';
                }
            } else if (this.certikTax.sell >= 5 && this.certikTax.sell < 20) {
                return '#FF7114';
            } else {
                return '#E55036';
            }
        },
    },

    created() {},

    methods: {
        // 切换代币/重新发起检测前：清空上一枚代币的检测结果，避免列表残留/叠加
        resetTokenSecurityResults() {
            this.tradeList = [];
            this.contractList = [];
            this.taxList = [];
            this.tokenAnalysis = [];

            this.goPlusTax = { buy: null, sell: null };
            this.certikTax = { buy: null, sell: null };

            this.certikTradeList = [];
            this.certikContractList = [];
            this.certikTokenAnalysis = [];
            this.certikTxList = [];
        },
        async getSolEpoch() {
            this.epoch = 0;
            const data = { jsonrpc: '2.0', id: 1, method: 'getEpochInfo' };
            try {
                const response = await fetch(`https://solana1.mytokenpocket.vip`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                const res = await response.json();
                // console.log('getSolEpoch', res);
                if (res.result) {
                    this.epoch = res.result.epoch;
                }
            } catch (error) {
                console.log(error);
            }
        },

        canEnter(val) {
            const objType = typeof val;
            let isEnter = false;
            if ((objType === 'object' && val && Object.keys(val).length > 0) || (objType !== 'object' && val !== '')) {
                isEnter = true;
            }
            return isEnter;
        },

        getTokenInfo(data) {
            reqTokenInfo(data)
                .then(res => {
                    if (res.result === 0 && res.data) {
                        this.tokenIcon = res.data.icon_url;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        async getTokenById(id) {
            try {
                const res = await reqTokenById({ id });
                // console.log('getTokenById', res);
                if (res.result === 0 && res.data) {
                    this.initTokenStatus(res.data.token_status);
                }
            } catch (error) {
                console.log(error);
            }
        },
        initTokenStatus(token_status) {
            if (token_status === 2 || token_status === 4) {
                // this.token_status = 2;
                const obj = {
                    label: 'tokenSecurityData.trade_token_status_text1',
                    status: 2,
                };
                this.tradeList.push(obj);
            }
        },

        async getTokenSecurity(address, blockchain_id, chainData) {
            this.isDetectionResult = false;
            if (!address || !blockchain_id) {
                return null;
            }

            const { ns, chain_id } = chainData || {};

            try {
                const res = await reqTokenSecurity({ address, ns, chain_id });
                // console.log('reqTokenSecurity', res);
                if (res.result === 0 && res.data !== null) {
                    res.data.address = address;
                    if ('owner_address' in res.data) {
                        res.data.owner_address = res.data.owner_address.trim();
                    }
                    this.isDetectionResult = true;
                    return res.data;
                }
                return null;
            } catch (error) {
                console.log(error);
                this.isDetectionResult = false;
                return null;
            }
        },

        requestTokenSecurity(address, blockchain_id) {
            return this.getTokenSecurity(address, blockchain_id).then(data => {
                if (!data) {
                    return null;
                }
                if (Number(blockchain_id) === 27) {
                    this.formatSolData(data);
                } else {
                    this.formatEvmData(data);
                }
                return data;
            });
        },

        startTokenSecurityPolling(address, blockchain_id) {
            if (!address || !blockchain_id) {
                return;
            }
            this.stopTokenSecurityPolling();
            this.tokenSecurityInterval = setInterval(() => {
                if (this.marketVisible === false) {
                    this.stopTokenSecurityPolling();
                    return;
                }
                this.requestTokenSecurity(address, blockchain_id);
            }, 60 * 1000);
        },

        stopTokenSecurityPolling() {
            if (this.tokenSecurityInterval) {
                clearInterval(this.tokenSecurityInterval);
                this.tokenSecurityInterval = null;
            }
        },

        formatEvmData(sources = []) {
            // 上层切换代币时已统一 reset，这里只做格式化
            const safeSources = Array.isArray(sources) ? sources : [];
            this.hasGoPlusSecuritySource = safeSources.some(
                item => item && item.source === 'goplus' && item.data !== null && item.data !== undefined
            );
            this.hasCertikSecuritySource = safeSources.some(
                item => item && item.source === 'certik' && item.data !== null && item.data !== undefined
            );

            safeSources.forEach(item => {
                item.data = parseData(item.data);
                // console.log('evm-data', item);
                if (item.source === 'goplus') {
                    this.formatGoPlusEvm(item.data);
                }
                if (item.source === 'certik') {
                    this.formatCertikEvm(item.data);
                }
            });
        },

        formatSolData(sources = []) {
            // 上层切换代币时已统一 reset，这里只做格式化
            // const goplusSource = sources.find(item => item.source === 'goplus');
            // goplusSource.data = parseData(goplusSource.data);
            // const certikSource = sources.find(item => item.source === 'certik');
            // certikSource.data = parseData(certikSource.data);
            // this.formatGoPlusSol(goplusSource.data);
            // this.formatCertikSol(certikSource.data);
            const safeSources = Array.isArray(sources) ? sources : [];
            this.hasGoPlusSecuritySource = safeSources.some(
                item => item && item.source === 'goplus' && item.data !== null && item.data !== undefined
            );
            this.hasCertikSecuritySource = safeSources.some(
                item => item && item.source === 'certik' && item.data !== null && item.data !== undefined
            );

            safeSources.forEach(item => {
                item.data = parseData(item.data);
                // console.log('sol-data', item);
                if (item.source === 'goplus') {
                    this.formatGoPlusSol(item.data);
                }
                if (item.source === 'certik') {
                    this.formatCertikSol(item.data);
                }
            });
        },

        formatGoPlusSol(data = {}) {
            // console.log('go-plus-sol', data);
            data.is_scheduled_fee_rate = data.transfer_fee?.scheduled_fee_rate?.length || false;
            data.buy_tax = data.transfer_fee?.current_fee_rate?.fee_rate || '';
            // data.sell_tax = '0.6'
            if (data.buy_tax) {
                this.goPlusTax.buy = truncateDecimals(divide(data.buy_tax, 100), 2);
            } else {
                this.goPlusTax.buy = 'unknown';
            }
            // console.log('goPlusTax', this.goPlusTax);
            this.createSolTradingList(data);
            this.createSolContract(data);
            this.createSolTaxList(data);
            this.createSolTokenAnalysis(data);
        },

        formatGoPlusEvm(data = {}) {
            // console.log('go-plus-evm', data);
            // delete data.selfdestruct;
            // data.selfdestruct = '1';
            // data.buy_tax = '0';
            // data.sell_tax = '0';
            if (data?.buy_tax) {
                this.goPlusTax.buy = truncateDecimals(multiply(data.buy_tax, 100), 2);
                // this.goPlusTax.buy = 5;
            } else if (data?.buy_tax === '') {
                this.goPlusTax.buy = 'unknown';
            }
            if (data?.sell_tax) {
                this.goPlusTax.sell = truncateDecimals(multiply(data.sell_tax, 100), 2);
                // this.goPlusTax.sell = 19;
            } else if (data?.sell_tax === '') {
                this.goPlusTax.sell = 'unknown';
            }
            // console.log('goPlusTax', this.goPlusTax);
            const { owner_address, hidden_owner, can_take_back_ownership } = data;
            const isHoleAddress = this.ownerSecurity(
                owner_address,
                hidden_owner === '0',
                can_take_back_ownership === '0'
            );
            // console.log('isHoleAddress', isHoleAddress)
            this.createTradeList(data, isHoleAddress);
            this.createContractList(data, isHoleAddress);
        },

        formatCertikSol(data = {}) {
            // console.log('certik-sol', data);
            // Solana: Certik 返回主要以 security_summary 为主
            // 目标：生成与 GoPlus 相同结构的行数据，供 UI 聚合展示（同 label 两列对比）
            // data.security_summary.transfer_fee_extension = {
            //     alert: true,
            //     extended_data: {
            //         newer_transfer_fee: {
            //             epoch: 1000,
            //             transfer_fee_basis_points: 3000,
            //             maximum_fee: 0,
            //         },
            //         older_transfer_fee: {
            //             epoch: 551,
            //             transfer_fee_basis_points: 800,
            //             maximum_fee: 100000000000,
            //         },
            //     },
            // };
            const { security_summary } = data || {};
            const summary = security_summary || {};

            this.certikTradeList = [];
            this.certikContractList = [];
            this.certikTokenAnalysis = [];
            this.certikTxList = [];

            const fee = summary.fee_in_basis_points?.extended_data?.effective_transfer_fee_basis_points || '';
            this.certikTax.buy = fee !== '' ? truncateDecimals(divide(fee, 100), 2) : 'unknown';

            if (summary.transfer_fee_extension?.alert) {
                const extended = summary.transfer_fee_extension?.extended_data || {};
                const older = extended.older_transfer_fee;
                const newer = extended.newer_transfer_fee;
                const currentEpoch = Number(this.epoch) || 0;

                if (!currentEpoch) {
                    this.getSolEpoch();
                }

                // Certik: 生成“交易税是否可调整”检测项（与 GoPlus 一致）
                if (older || newer) {
                    this.certikTxList.push({
                        label: 'scheduled_fee_rate',
                        scheduled: true,
                        epoch1: 0,
                        fee_rate: 0,
                        status: 0,
                        result: 'No',
                    });
                } else {
                    const statusFromRate = rate => {
                        if (!Number.isFinite(rate)) return 0;
                        if (rate < 5) return 0;
                        if (rate < 20) return 1;
                        return 2;
                    };

                    const formatRate = rate => {
                        const num = Number(rate);
                        return Number.isFinite(num) ? num.toFixed(2) : rate;
                    };

                    const scheduleList = [older, newer]
                        .map(item => {
                            const epoch = Number(item.epoch);
                            const rawRate = truncateDecimals(divide(item.transfer_fee_basis_points, 100), 2);
                            const rateNum = Number(rawRate);
                            return {
                                epoch,
                                fee_rate: formatRate(rawRate),
                                status: statusFromRate(rateNum),
                            };
                        })
                        .filter(item => Number.isFinite(item.epoch))
                        .sort((a, b) => a.epoch - b.epoch);

                    if (scheduleList.length) {
                        const maxStatus = scheduleList.reduce((max, item) => Math.max(max, item.status), 0);
                        const row = {
                            label: 'scheduled_fee_rate',
                            scheduled: true,
                            status: maxStatus,
                            result: 'Yes',
                            scheduleList,
                        };

                        if (scheduleList.length === 1) {
                            row.epoch1 = Number(scheduleList[0].epoch);
                            row.fee_rate = scheduleList[0].fee_rate;
                        }

                        this.certikTxList.push(row);
                    }
                }
            }

            // 仅依赖 alert + extended_data
            // - 默认 alert=true => status=1/result=Yes
            // - 少数高危项（按 key 规则）alert=true => status=2
            const isHighRiskKey = key =>
                key === 'closing_mint_extension' ||
                key === 'permanent_delegate_extension' ||
                key === 'withdraw_withheld_authority';

            const pushRow = (target, row) => {
                if (!target) return;
                if (!row || !row.label) return;
                target.push(row);
            };

            Object.keys(summary).forEach(certikKey => {
                const item = summary[certikKey];
                if (!item || typeof item !== 'object') return;

                // 统一 label（尽量对齐 GoPlus 字段名，便于聚合到同一行）
                const label = certikToGoPlusLabelMap[certikKey] || certikKey;

                // 类目归类：优先以 Certik Sol 枚举判断，兜底用 GoPlus Sol 枚举
                let target = null;
                if (enuCertikSolTrade.includes(certikKey) || enuSolTrade.includes(label)) {
                    target = this.certikTradeList;
                } else if (enuCertikSolContract.includes(certikKey) || enuSolContract.includes(label)) {
                    target = this.certikContractList;
                } else if (enuSolCertikTokenAnalysis.includes(certikKey) || enuSolTokenAnalysis.includes(label)) {
                    target = this.certikTokenAnalysis;
                } else {
                    // 未纳入 UI 的检测项，先跳过（后续需要可补 i18n/枚举）
                    return;
                }

                const isAlertTrue = !!item.alert;
                const extended = (item && typeof item.extended_data === 'object' && item.extended_data) || {};

                // 按你最新标注：Solana 相关字段统一为 true=异常 / false=正常
                const isAbnormal = isAlertTrue;
                const isNormal = !isAbnormal;

                // 默认：alert=true => Yes + 风险等级；alert=false => No + 安全
                const row = {
                    label,
                    result: '-',
                    status: 0,
                };

                // ===== Solana 字段语义对齐（与 createSol* 规则保持一致） =====
                if (certikKey === 'token_launch_time') {
                    // 新代币：无论 alert true/false，都不计入风险（按产品规则强制安全）
                    row.result = isAlertTrue ? 'Yes' : 'No';
                    row.status = 3;
                } else if (certikKey === 'non_transferable_token_extension' || label === 'non_transferable') {
                    // 你标注：true=异常（不可转账），false=正常（可转账）
                    // UI 文案是“代币是否能转账”：正常 => Yes(安全)，异常 => No(高风险)
                    row.result = isAbnormal ? 'No' : 'Yes';
                    row.status = isAbnormal ? 2 : 0;
                } else if (label === 'metadata_mutable') {
                    // alert=true 表示元数据可变更；若 extended_data 有 update_authority，则展示地址并按高风险处理
                    if (!isAbnormal) {
                        row.result = 'No';
                        row.status = 0;
                    } else {
                        row.result = 'Yes';
                        const updateAuthority = extended.update_authority;
                        if (updateAuthority) {
                            row.metadata_mutable = true;
                            row.status = 2;
                        } else {
                            row.status = 1;
                        }
                    }
                } else if (label === 'closable' || label === 'balance_mutable_authority') {
                    // 这两项在现有 Sol 逻辑里属于“存在即高风险”
                    row.result = isAbnormal ? 'Yes' : 'No';
                    row.status = isAbnormal ? 2 : 0;
                } else if (
                    certikKey === 'liquidity_control' ||
                    certikKey === 'major_holders_ratio' ||
                    certikKey === 'initial_distribution'
                ) {
                    // 你标注：true=正常，false=异常；这些字段本身就是“是否正常”的含义
                    row.result = isNormal ? 'Yes' : 'No';
                    row.status = isNormal ? 0 : 1;
                } else {
                    // 其余字段：你标注为 true=异常/存在风险，false=正常
                    row.result = isAbnormal ? 'Yes' : 'No';
                    row.status = isAbnormal ? (isHighRiskKey(certikKey) ? 2 : 1) : 0;
                }

                // 安全状态不展示
                if (
                    row.status === 0 &&
                    (label === 'confidential_transfer_extension' || label === 'interest_bearing_token_extension')
                ) {
                    return;
                }

                // transfer_hook：展示外部程序地址到 tip（与 GoPlus 行为对齐）
                if (label === 'transfer_hook') {
                    row.transfer_hook = true;
                    // Certik: transfer_hook_extension 外部程序地址在 extended_data.authority
                    // 只根据 authority 是否存在来判断，并把地址存到 row.addresses 供 tooltip/聚合展示
                    const authority = extended && typeof extended === 'object' ? extended.authority : undefined;
                    const authorityStr = authority === null || authority === undefined ? '' : String(authority).trim();
                    if (authorityStr) {
                        row.addresses = [authorityStr];
                        row.result = 'Yes';
                        row.status = 1;
                    } else {
                        row.result = 'No';
                        row.status = 0;
                    }
                }

                pushRow(target, row);
            });

            this.certikTradeList.sort((a, b) => b.status - a.status);
            this.certikContractList.sort((a, b) => b.status - a.status);
            this.certikTokenAnalysis.sort((a, b) => b.status - a.status);
            // console.log('certikTradeList', cloneDeep(this.certikTradeList));
            // console.log('certikContractList', cloneDeep(this.certikContractList));
            // console.log('certikTokenAnalysis', cloneDeep(this.certikTokenAnalysis));
            // console.log('certikTxList', cloneDeep(this.certikTxList));
        },

        formatCertikEvm(data = {}) {
            // console.log('certik-evm', data);
            // data.security_summary.can_modify_balance = {
            //     alert: true,
            //     alert_level: 'Critical',
            //     alert_msg:
            //         'If privileged roles have the ability to modify balances, it can lead to potential misuse or abuse of power, where token balances could be altered arbitrarily or maliciously.',
            //     alert_summary: 'Token balance cannot be modified by privileged roles',
            //     category: 'Centralization',
            //     description: 'Check if the token balance can be modified by privileged roles',
            //     extended_data: null,
            // };
            const { security_summary } = data;

            // ===== 黑洞地址逻辑：不依赖 GoPlus，尽量从 Certik 响应里补齐 =====
            // 目标是给 ownerSecurity 提供：owner_address + hidden_owner + can_take_back_ownership
            // - hidden_owner：来自 Certik 的 has_hidden_owner（alert=true => 1）
            // - can_take_back_ownership：来自 Certik 的 can_regain_ownership（alert=true => 1）
            // - owner_address：字段已确定为 token_info.owner

            const summaryForHole = security_summary || {};
            const hidden_owner = summaryForHole?.has_hidden_owner?.alert;
            const can_take_back_ownership = summaryForHole?.can_regain_ownership?.alert;

            const ownerFromTokenInfo = typeof data?.token_info?.owner === 'string' ? data.token_info.owner.trim() : '';
            const ownerAddressDirect = typeof data?.owner_address === 'string' ? data.owner_address.trim() : '';
            const owner_address = ownerFromTokenInfo || ownerAddressDirect;

            const isHoleAddress = this.ownerSecurity(owner_address, !hidden_owner, !can_take_back_ownership);

            const buy_tax = security_summary?.buy_tax?.extended_data?.buy_tax.slice(0, -1);
            // buy_tax = 6;
            // console.log('buy_tax', buy_tax);
            this.certikTax.buy = buy_tax ? truncateDecimals(buy_tax, 2) : 'unknown';
            const sell_tax = security_summary?.sell_tax?.extended_data?.sell_tax.slice(0, -1);
            // sell_tax = 51;
            // console.log('sell_tax', sell_tax);
            this.certikTax.sell = sell_tax ? truncateDecimals(sell_tax, 2) : 'unknown';
            // console.log('certikTax', this.certikTax);

            // 生成 Certik 独立检测项列表：用于页面同一行展示 GoPlus / Certik 两列结果
            this.certikTradeList = [];
            this.certikContractList = [];

            const summary = security_summary || {};

            const buildRow = (certikKey, item, target) => {
                const label = certikToGoPlusLabelMap[certikKey] || certikKey;
                const row = { label, result: '-', status: 0 };
                const alert = !!item.alert;

                if (!alert) {
                    row.result = 'No';
                    row.status = 0;
                } else {
                    row.result = 'Yes';
                    row.status = 1;
                }

                // 关键：label 已统一成 GoPlus 的字段语义，因此这里也要按该语义生成 Yes/No
                if (label === 'is_open_source' && certikKey === 'not_open_source') {
                    const isOpenSource = !alert;
                    row.result = isOpenSource ? 'Yes' : 'No';
                    row.status = isOpenSource ? 0 : 2;
                }

                if (label === 'is_honeypot') {
                    row.result = alert ? 'Yes' : 'No';
                    row.status = alert ? 2 : 0;
                }

                if (label === 'selfdestruct' && certikKey === 'can_self_destruct') {
                    row.result = alert ? 'Yes' : 'No';
                    row.status = alert ? 2 : 0;
                }

                // ===== 复用 GoPlus 的特殊处理规则（保证两数据源行为一致） =====
                // cannot_buy / cannot_sell_all：安全（=0）时不展示
                if ((label === 'cannot_buy' || label === 'cannot_sell_all') && row.status === 0) {
                    return;
                }

                if (isHoleAddress) {
                    // 黑洞地址：以下项目展示但强制安全（与 GoPlus 保持一致）
                    if (
                        label === 'slippage_modifiable' ||
                        label === 'transfer_pausable' ||
                        label === 'trading_cooldown' ||
                        label === 'anti_whale_modifiable' ||
                        label === 'is_blacklisted' ||
                        label === 'is_whitelisted'
                    ) {
                        row.status = 0;
                        row.result = 'No';
                    }

                    // 黑洞地址：合约相关（增发/修改余额/自毁）也强制安全
                    if (
                        label === 'is_mintable' ||
                        label === 'selfdestruct' ||
                        (label === 'owner_change_balance' && certikKey === 'can_modify_balance')
                    ) {
                        row.status = 0;
                        row.result = 'No';
                    }
                }

                // 兼容“集中度”这种扩展值（如果后续 UI 要展示可以继续用 tip/扩展字段）
                if (label === 'major_holder_ratio') {
                    const percentRaw = item?.extended_data?.percent;
                    const percent = Number(String(percentRaw ?? '').replace('%', ''));
                    if (!Number.isNaN(percent)) {
                        row.major_holder_ratio_percent = percent;
                        if (percent > 50) {
                            row.status = 2;
                            row.result = 'Yes';
                        } else {
                            row.status = 0;
                            row.result = 'No';
                        }
                    }
                }

                target.push(row);
            };

            // 只处理枚举内的字段
            enuCertikTrade.forEach(certikKey => {
                const item = summary[certikKey];
                if (!item || typeof item !== 'object') return;
                buildRow(certikKey, item, this.certikTradeList);
            });

            enuCertikContract.forEach(certikKey => {
                const item = summary[certikKey];
                if (!item || typeof item !== 'object') return;
                buildRow(certikKey, item, this.certikContractList);
            });

            this.certikTradeList.sort((a, b) => b.status - a.status);
            this.certikContractList.sort((a, b) => b.status - a.status);
            // console.log('certikTradeList', cloneDeep(this.certikTradeList));
            // console.log('certikContractList', cloneDeep(this.certikContractList));
        },

        // owner为黑洞, hidden_owner为0, can_take_back_ownership为0同时满足时，
        // 表格中“受owner权限影响”中打v的，不进行安全风险统计，也不进行展示。
        ownerSecurity(owner_address, hidden_owner, can_take_back_ownership) {
            if (owner_address) {
                if (
                    holeAddressList.indexOf(owner_address.toLowerCase()) > -1 &&
                    hidden_owner &&
                    can_take_back_ownership
                ) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        },
        createTradeList(tokenInfo, isHoleAddress) {
            // this.tradeList = [];
            enuTrade.forEach(item => {
                if (tokenInfo[item]) {
                    // console.log('trade--', item, 'value--', tokenInfo[item])
                    const obj = {};
                    obj[item] = tokenInfo[item];
                    obj.label = item;
                    obj.result = '-';
                    if (tokenInfo[item] == 0) {
                        obj.status = 0;
                        obj.result = 'No';
                    } else {
                        obj.status = 1;
                        obj.result = 'Yes';
                        // console.log('label', obj.label);
                        if (item === 'is_honeypot') {
                            obj.status = 2;
                        }
                    }
                    if (
                        (item === 'cannot_buy' && tokenInfo['cannot_buy'] == 0) ||
                        (item === 'cannot_sell_all' && tokenInfo['cannot_sell_all'] == 0)
                    ) {
                        // console.log('不存入--', item);
                    } else {
                        if (
                            isHoleAddress &&
                            (item === 'slippage_modifiable' ||
                                item === 'transfer_pausable' ||
                                item === 'trading_cooldown' ||
                                item === 'personal_slippage_modifiable' ||
                                item === 'is_blacklisted' ||
                                item === 'is_whitelisted' ||
                                item === 'anti_whale_modifiable')
                        ) {
                            // console.log('存入', item);
                            obj.status = 0;
                            obj.result = 'No';
                        }

                        this.tradeList.push(obj);
                    }
                }
            });
            this.tradeList.sort((a, b) => b.status - a.status);
            // console.log('tradeList', cloneDeep(this.tradeList));
        },
        createContractList(tokenInfo, isHoleAddress) {
            // this.contractList = [];
            enuContract.forEach(item => {
                if (tokenInfo[item]) {
                    // console.log('contract--', item, 'value--', tokenInfo[item])
                    const obj = {};
                    obj.label = item;
                    // owner为黑洞, hidden_owner为0, can_take_back_ownership为0同时满足时，可以判定为owner权限已丢弃
                    // 不管数据是 0 还是 1 都是没有风险, 增发和修改余额的描述改变,
                    if (
                        isHoleAddress &&
                        (item === 'is_mintable' || item === 'owner_change_balance' || item === 'selfdestruct')
                    ) {
                        obj.status = 0;
                        obj.result = 'No';
                        this.contractList.push(obj);
                    }
                    // 这个几个属性是为 1 的时候是安全的
                    else if (item === 'is_open_source' || item === 'is_true_token') {
                        if (tokenInfo[item] == 1) {
                            obj[item] = obj.status = 0;
                            obj.result = 'Yes';
                            if (item === 'is_open_source') {
                                this.contractList.push(obj);
                            }
                        } else {
                            obj[item] = obj.status = 2;
                            obj.result = 'No';
                            this.contractList.push(obj);
                        }
                    }
                    // 这个几个属性是为 0 的时候是安全的
                    else {
                        if (tokenInfo[item] == 0) {
                            obj[item] = obj.status = Number(tokenInfo[item]);
                            obj.result = 'No';

                            if (item !== 'is_airdrop_scam') {
                                this.contractList.push(obj);
                            }
                        } else {
                            obj[item] = obj.status = Number(tokenInfo[item]);
                            obj.result = 'Yes';
                            if (item === 'is_open_source' || item === 'is_airdrop_scam' || item === 'selfdestruct') {
                                obj.status = 2;
                            } else {
                                // 显示警告
                                obj.status = 1;
                            }
                            // 满足条件风险不统计展示内容变化
                            // if (
                            //   isHoleAddress &&
                            //   (item === 'is_mintable' || item === 'owner_change_balance')
                            // ) {
                            //   console.log('contract不存入--', item);
                            //   obj.label = this.contract_2_HoleAddress_Map[item];
                            //   obj.status = 0;
                            //   this.contractList.push(obj);
                            // } else {
                            // }
                            this.contractList.push(obj);
                        }
                    }
                }
            });
            this.contractList.sort((a, b) => b.status - a.status);
            // console.log('contractList', cloneDeep(this.contractList));
        },

        createSolTradingList(data) {
            let list = [];
            enuSolTrade.forEach(item => {
                const isEnter = this.canEnter(data[item]);
                if (item in data && isEnter) {
                    const obj = {};
                    obj[item] = item;
                    obj.label = item;
                    obj.result = '-';

                    if (data[item]?.status === '0') {
                        obj.status = 0;
                        obj.result = 'No';
                    } else {
                        obj.status = 1;
                        obj.result = 'Yes';
                    }

                    list.push(obj);
                }
            });
            list = list.filter(item => item.label);
            list = list.sort((a, b) => b.status - a.status);
            this.tradeList = list;
            // console.log('tradeList', cloneDeep(this.tradeList));
        },
        createSolContract(tokenInfo) {
            let list = [];
            enuSolContract.forEach(item => {
                let isEnter = this.canEnter(tokenInfo[item]);
                if (item === 'transfer_hook' || item === 'creators') {
                    isEnter = true;
                }
                if ((item in tokenInfo || item === 'transfer_hook' || item === 'creators') && isEnter) {
                    const obj = {};
                    obj[item] = item;
                    obj.label = item;
                    obj.result = '-';
                    // 0是安全的
                    if (item === 'non_transferable') {
                        if (tokenInfo[item] === '0') {
                            obj.status = 0;
                            obj.result = 'Yes';
                        } else {
                            obj.status = 2;
                            obj.result = 'No';
                        }
                        list.push(obj);
                    } else if (item === 'default_account_state') {
                        if (tokenInfo[item] === '0') {
                            obj.status = 1;
                            obj.result = 'No';
                        } else if (tokenInfo[item] === '1') {
                            obj.status = 0;
                            obj.result = 'Yes';
                        } else {
                            obj.status = 2;
                            obj.result = 'No';
                        }
                        list.push(obj);
                    }
                    // 1是安全的
                    else if (item === 'trusted_token') {
                        if (Number(tokenInfo[item]) === 1) {
                            obj.status = 0;
                            obj.result = 'Yes';
                            list.push(obj);
                        }
                    } else if (item === 'creators') {
                        // creators: [{ address, malicious_address }]
                        // 1) 有 address 且 malicious_address 空/0：展示 address，提示“不是恶意”，status=0
                        // 2) 有 address 且 malicious_address=1：展示 address，提示“恶意”，status=2
                        // 3) creators 为空：地址不展示，不提示是否恶意
                        const creators = tokenInfo && Array.isArray(tokenInfo.creators) ? tokenInfo.creators : [];
                        const creator = creators.find(c => c && c.address);

                        if (creator && creator.address) {
                            const isMalicious =
                                creator.malicious_address == '1' ||
                                creator.malicious_address === 1 ||
                                creator.malicious_address === true;

                            if (isMalicious) {
                                obj.status = 2;
                                obj.result = 'Yes';
                            } else {
                                obj.status = 0;
                                obj.result = 'No';
                            }
                        } else {
                            obj.status = 0;
                            obj.result = 'No';
                        }
                        list.push(obj);
                    } else if (item === 'transfer_hook') {
                        obj.transfer_hook = true;
                        const addresses = [];
                        if (tokenInfo[item] && tokenInfo[item].length) {
                            tokenInfo[item].forEach(item => {
                                if (item.address) {
                                    addresses.push(item.address);
                                }
                            });
                            const flag = tokenInfo[item].some(item => item.address && item.malicious_address == '1');
                            if (flag) {
                                obj.status = 2;
                            } else {
                                obj.status = 1;
                            }
                            obj.result = 'Yes';
                        } else {
                            // obj.label = sol_trade_0_map[item];
                            obj.status = 0;
                            obj.result = 'No';
                        }
                        obj.addresses = addresses;
                        list.push(obj);
                    } else if (tokenInfo[item]?.status == '0') {
                        // obj.label = sol_contract_0_map[item];
                        obj.status = 0;
                        obj.result = 'Yes';
                        list.push(obj);
                    } else {
                        // obj.label = sol_contract_1_map[item];
                        obj.status = 1;
                        obj.result = 'No';
                        list.push(obj);
                    }
                }
            });
            list = list.filter(item => item.label);
            list = list.sort((a, b) => b.status - a.status);
            this.contractList = list;
            // console.log('contractList', cloneDeep(this.contractList));
        },
        createSolTaxList(tokenInfo) {
            this.taxList = [];
            let list = [];
            const scheduled_fee_rate = tokenInfo.transfer_fee?.scheduled_fee_rate;
            // const scheduled_fee_rate = [
            //     {
            //         epoch: '930',
            //         fee_rate: '300',
            //         maximum_fee: '0',
            //     },
            //     {
            //         epoch: '1000',
            //         fee_rate: '400',
            //         maximum_fee: '0',
            //     },
            //     {
            //         epoch: '2000',
            //         fee_rate: '2000',
            //         maximum_fee: '0',
            //     },
            // ];

            const statusFromRate = rate => {
                if (!Number.isFinite(rate)) return 0;
                if (rate < 5) return 0;
                if (rate < 20) return 1;
                return 2;
            };

            const formatRate = rate => {
                const num = Number(rate);
                return Number.isFinite(num) ? num.toFixed(2) : rate;
            };

            // 没有任何计划变更：也展示该检测项（safe）
            if (!Array.isArray(scheduled_fee_rate) || scheduled_fee_rate.length === 0) {
                list.push({
                    label: 'scheduled_fee_rate',
                    scheduled: true,
                    epoch1: 0,
                    fee_rate: 0,
                    status: 0,
                    result: 'No',
                    scheduleList: [],
                });
            } else {
                const scheduleList = scheduled_fee_rate
                    .map(item => {
                        const epoch = Number(item.epoch);
                        const rawRate = truncateDecimals(divide(item.fee_rate, 100), 2);
                        const rateNum = Number(rawRate);
                        return {
                            epoch,
                            fee_rate: formatRate(rawRate),
                            status: statusFromRate(rateNum),
                        };
                    })
                    .filter(item => Number.isFinite(item.epoch))
                    .sort((a, b) => a.epoch - b.epoch);

                const maxStatus = scheduleList.reduce((max, item) => Math.max(max, item.status), 0);
                const obj = {
                    label: 'scheduled_fee_rate',
                    scheduled: true,
                    status: maxStatus,
                    result: 'Yes',
                    scheduleList,
                };

                if (scheduleList.length === 1) {
                    obj.epoch1 = Number(scheduleList[0].epoch);
                    obj.fee_rate = scheduleList[0].fee_rate;
                }

                list.push(obj);

                if (!this.epoch || this.epoch <= 0) {
                    this.getSolEpoch();
                }
            }

            // list = [...this.tradeList, ...list];
            list = list.sort((a, b) => b.status - a.status);
            // this.tradeList = list;
            this.taxList = list;
            // console.log('taxList', cloneDeep(this.taxList));
        },
        createSolTokenAnalysis(data) {
            let list = [];
            // data.metadata_mutable.metadata_upgrade_authority = [
            //     {
            //         address: '',
            //         malicious_address: 0,
            //     },
            // ];
            // BAGSB9TpGrZxQbEsrEznv5jXXdwyP6AXerN8aVRiAmcv
            // console.log('createSolTokenAnalysis', data);
            enuSolTokenAnalysis.forEach(item => {
                const isEnter = this.canEnter(data[item]);
                if (item in data && isEnter) {
                    // 只有这个字段的 address 做判断
                    const obj = {};
                    obj[item] = item;
                    obj.label = item;
                    obj.result = '-';
                    if (item === 'metadata_mutable') {
                        if (data[item]?.status == '0') {
                            obj.status = 0;
                            obj.result = 'No';
                        } else if (data[item]?.status == '1') {
                            const list = data[item]?.metadata_upgrade_authority || [];
                            if (list.length) {
                                obj.metadata_mutable = true;
                                const hasAddress = list.some(item1 => item1.address);
                                if (hasAddress) {
                                    obj.status = 2;
                                    obj.result = 'Yes';
                                } else {
                                    obj.status = 1;
                                    obj.result = 'Yes';
                                }
                            } else {
                                obj.status = 1;
                                obj.result = 'Yes';
                            }
                        }
                        list.push(obj);
                    } else if (item === 'closable' || item === 'balance_mutable_authority') {
                        if (data[item]?.status == '0') {
                            // obj.label = sol_contract_0_map[item];
                            obj.status = 0;
                            obj.result = 'No';
                        } else {
                            // obj.label = sol_contract_2_map[item];
                            obj.status = 2;
                            obj.result = 'Yes';
                        }
                        list.push(obj);
                    } else {
                        if (data[item]?.status === '0') {
                            obj.status = 0;
                            obj.result = 'No';
                        } else {
                            obj.status = 1;
                            obj.result = 'Yes';
                        }
                        list.push(obj);
                    }
                }
            });

            list = list.sort((a, b) => b.status - a.status);
            this.tokenAnalysis = list;
            // console.log('tokenAnalysis', cloneDeep(this.tokenAnalysis));
        },
    },
};
